import { useEffect, useState } from "react";
import PageHero from "../../components/shared/PageHero";
import CtaBand from "../../components/shared/CtaBand";
import SipCalculator from "../../components/Calculators/SipCalculator";
import LumpsumCalculator from "../../components/Calculators/LumpsumCalculator";
import RetirementCalculator from "../../components/Calculators/RetirementCalculator";
import EmiCalculator from "../../components/Calculators/EmiCalculator";
import CagrCalculator from "../../components/Calculators/CagrCalculator";
import GoalCalculator from "../../components/Calculators/GoalCalculator";
import BondYieldCalculator from "../../components/Calculators/BondYieldCalculator";
import "./CalculatorsPage.css";

const NAV = [
  { id: "sip", label: "SIP" },
  { id: "lumpsum", label: "Lumpsum" },
  { id: "retirement", label: "Retirement" },
  { id: "emi", label: "EMI" },
  { id: "cagr", label: "CAGR" },
  { id: "goal", label: "Goal" },
  { id: "bond-yield", label: "Bond Yield" },
];

export default function CalculatorsPage() {
  const [active, setActive] = useState("sip");

  useEffect(() => {
    window.scrollTo(0, 0);

    const sections = NAV.map((n) => document.getElementById(n.id)).filter(Boolean);
    const obs = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible?.target?.id) setActive(visible.target.id);
      },
      { rootMargin: "-30% 0px -55% 0px", threshold: [0.15, 0.4, 0.7] }
    );
    sections.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <main className="calc-page">
      <PageHero
        badge="Tools"
        title="Investment calculators"
        subtitle="Plan SIPs, lumpsum growth, retirement corpus, EMIs, CAGR, goals, and bond yields — all live, client-side, and free to use."
        actions={[
          { label: "Start with SIP", to: "#sip", primary: true },
          { label: "Review Portfolio", to: "/portfolio-review" },
        ]}
      />

      <nav className="calc-subnav" aria-label="Calculator types">
        <div className="pm-container calc-subnav__inner">
          {NAV.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`calc-subnav__link ${
                active === item.id ? "calc-subnav__link--active" : ""
              }`}
              onClick={() => setActive(item.id)}
            >
              {item.label}
            </a>
          ))}
        </div>
      </nav>

      <div className="pm-container calc-stack">
        <SipCalculator />
        <LumpsumCalculator />
        <RetirementCalculator />
        <EmiCalculator />
        <CagrCalculator />
        <GoalCalculator />
        <BondYieldCalculator />
      </div>

      <CtaBand
        title="Numbers look good — ready for a plan?"
        subtitle="Pair these calculators with a free portfolio review from Poonji Mitra."
        primary={{ label: "Book Free Consultation", to: "/contact" }}
        secondary={{ label: "Review My Portfolio", to: "/portfolio-review" }}
      />
    </main>
  );
}
